export default __webpack_public_path__ + "static/prioritize-inclusive-ea6322412590942a446a31429437e8e0.mp4";